import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutUsComponent } from './about-us/about-us.component';
import { OurTeamComponent } from './our-team/our-team.component';
import { RouterModule, Routes } from '@angular/router';
import {IvyCarouselModule} from 'angular-responsive-carousel';
import { AboutComponent } from './about.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { PopupMission } from 'src/app/shared/components/popup-mission/popup-mission.component';
import { PopupVision } from 'src/app/shared/components/popup-vision/popup-vision.component';


const routes:Routes = [
  {
    path: '',
    component: AboutComponent
  },
  {
    path: 'sobre-nosotros',
    component: AboutUsComponent
  },
  {
    path: 'nuestro-equipo',
    component: OurTeamComponent
  }
]

@NgModule({
  declarations: [AboutUsComponent, OurTeamComponent, AboutComponent, PopupMission, PopupVision],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    MatDialogModule,
    IvyCarouselModule,
    TranslateModule.forChild(),

  ]
})
export class AboutModule { }
